import { render, staticRenderFns } from "./addFansMange.vue?vue&type=template&id=38938c4b&scoped=true"
import script from "./addFansMange.vue?vue&type=script&lang=js"
export * from "./addFansMange.vue?vue&type=script&lang=js"
import style0 from "./addFansMange.vue?vue&type=style&index=0&id=38938c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38938c4b",
  null
  
)

export default component.exports